// 集中导出的保护类型枚举，供全站引用与校验

export const PROTECTION_TYPES = [
  'overcurrent',
  'distance',
  'differential',
  'directional',
  'zero_sequence',
  'longitudinal'
];

export const PROTECTION_TYPE_SET = new Set(PROTECTION_TYPES);

export const isValidProtectionType = (type) => PROTECTION_TYPE_SET.has(type);